module.exports = __webpack_public_path__ + "static/media/item_34_3.fe8ab702.png";